module.exports = __webpack_public_path__ + "assets/icon-animalType-sheep.217f13ff.svg";